import React from "react";
import "../../../css/DesignSystem/Buttons/SignInButton.css";

const SignInButton = ({ imgSrc, title, onClick, disabled }) => {
  return (
    <div className={`SignInButton-Container ${disabled ? "disabled" : ""}`} onClick={disabled ? null : onClick}>
      <img src={imgSrc} alt="icon" />
      <div className="Content-Large">{title}</div>
    </div>
  );
};
export default SignInButton;
